import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';

@Component({
  selector: 'app-add-material-and-process',
  templateUrl: './add-material-and-process.component.html',
  styleUrls: ['./add-material-and-process.component.css']
})
export class AddMaterialAndProcessComponent implements OnInit {
  checkboxError = false;
  form!: FormGroup;
  roadTypeName: any = "Asphalt Road";

  roadTypes = ["Asphalt Road", "Concrete Road", "Gravel Road", "Paver Block Road", "Bituminous Road", "Dirt Road", "Cycle Path/Footpath"]
  asphaltRoad = ["Site clearing and grading", "Excavation", "Subgrade compaction", "Base layer placement (aggregate)", "Application of binder", "Asphalt paving and rolling",];
  concreteRoad = ["Site clearing and leveling", "Subgrade compaction", " Base layer placement", "Formwork setup", " Pouring of concrete", "Curing for 28 days",];
  gravelRoad = ["Site clearing", "Grading and leveling", "Compaction of subgrade", "Placement of gravel layers", "Compaction", "Subgrade preparation",];
  paverBlockRoad = ["Subgrade preparation", "Sand leveling", "Laying of paver blocks", "Joint filling with fine sand", "Final compaction"];
  bituminousRoad = ["Clearing and leveling", "Subgrade preparation", "Base layer compaction", "Application of bitumen and aggregates", "Rolling"];
  dirtRoad = ["Site clearing", "Grading", "Leveling and compacting"];
  cyclePath = ["Clearing vegetation", "Leveling", "Subgrade compaction", "Surfacing (asphalt, concrete, or paver blocks)"];
  expandedStates: boolean[] = [];
  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.form = this.fb.group({ 
      typeofRoad: ['', Validators.required], constructionSteps: this.fb.array([]),
       materialsNeeded: ['Aggregate, bitumen, sand, asphalt binder, prime coat, tack coat, sealant, drainage work, labor', Validators.required], 
       machinesEquipment: ['Asphalt paver, road roller, bitumen distributor, loader, grader, vibratory compactor', Validators.required], 
       basicRequirements: ['Stable subgrade (CBR ≥ 5%), drainage system, bitumen quality meeting penetration grade standards', Validators.required], 
       perLaneDimension: ['3.0–3.75 meters wide for a single lane', Validators.required], });
       this.form.get('typeofRoad')?.valueChanges.subscribe(type => { 
        this.roadTypeName = type; this.buildConstructionSteps(type); 
      });
  }
 

  buildConstructionSteps(type: string) {
     const steps = this.getRoadSteps(type); 
     const stepFormGroups = steps.map(step => this.fb.group({ 
      label: [step], value: [''] })); 
      this.form.setControl('constructionSteps', this.fb.array(stepFormGroups)); }

  updateCheckboxes(type: string) {
    const options = this.getRoadSteps(type);
    const controls = options.map(() => new FormControl());
    this.form.setControl('constructionSteps', this.fb.array(controls));
  }

  getRoadSteps(type: string): string[] {
    switch (type) {
      case 'Asphalt Road': return this.asphaltRoad;
      case 'Concrete Road': return this.concreteRoad;
      case 'Gravel Road': return this.gravelRoad;
      case 'Paver Block Road': return this.paverBlockRoad;
      case 'Bituminous Road': return this.bituminousRoad;
      case 'Dirt Road': return this.dirtRoad;
      case 'Cycle Path/Footpath': return this.cyclePath;
      default: return [];
    }
  }




  get constructionStepsFormArray(): FormArray { return this.form.get('constructionSteps') as FormArray; }

  
  onSubmit() { 
    const steps = this.constructionStepsFormArray.value; const validSteps = steps.filter((s: { value: string; }) => s.value && s.value.trim() !== '');

    this.checkboxError = validSteps.length === 0;
    
    if (this.form.valid) { const payload = { ...this.form.value, selectedConstructionSteps: validSteps }; console.log(' Final Payload:', payload);}
  }

}

